const {Component} = require("react");
const PropTypes = require("prop-types");
const router = require("services/router");

class Icon extends Component {

    static get propTypes() {
        return {
            title: PropTypes.string,
            name: PropTypes.string.isRequired,
        };
    }

    static get defaultProps() {
        return {
            title: ''
        };
    }

    get url() {
        const path = "img/backend/icons/" + this.props.name + ".svg";

        return router.url(path);
    }

    render() {
        return (
            <img src={this.url} alt={this.props.title}/>
        );
    }

}

module.exports = Icon;
